
import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { APIResult } from "models/api-results";
import { Job, JobAllocation, JobFilterparam } from "../../models/job/job";
import { BaseSearchParam } from "models/base-search-param";
import { Invoice } from "../../models/invoice/invoice";
import { JobAssignRequestModel } from "models/job/job-assignment-request";


export async function CreateJob(param: Job): Promise<APIResult<Job>> {
    return await WebAPIClient.postData<Job>(ApiEndPoints.job_create, param);
}
export async function UpdateJob(param: Job): Promise<APIResult<Job>> {
    return await WebAPIClient.patchData<Job>(ApiEndPoints.job_update.replace("{id}", (param?.id ?? 0).toString()), param);
}
export async function GetJobs(param: JobFilterparam, sort?: string, pageSize?: number, pageNumber?: number): Promise<APIResult<Job[]>> {

    const searchParams = new BaseSearchParam(param, sort, pageSize, pageNumber);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.job_search}${queryString}`;
    return await WebAPIClient.getData<Job[]>(apiUrl);
}

export async function GetJobDetails(id: string): Promise<APIResult<Job>> {
    const apiUrl = `${ApiEndPoints.job_select}`;
    return await WebAPIClient.getData<Job>(apiUrl.replace("{id}", (id ?? 0).toString()));
}


export async function GenerateInvoice(id: string): Promise<APIResult<Invoice>> {
    const apiUrl = `${ApiEndPoints.invoice_create}`;
    return await WebAPIClient.postData<Job>(apiUrl.replace("{id}", (id ?? 0).toString()), {});
}

export async function ViewInvoiceByJobId(id: string): Promise<any> {
    const apiUrl = `${ApiEndPoints.invoice_View_By_Job}`;
    return await WebAPIClient.getBlobData<any>(apiUrl.replace("{id}", (id ?? 0).toString()));
}
export async function PreviewInvoiceByJobId(id: string): Promise<APIResult<{
    htmlContent: string
}>> {
    const apiUrl = `${ApiEndPoints.invoice_preview_by_job}`;
    return await WebAPIClient.getData<{
        htmlContent: string
    }>(apiUrl.replace("{id}", (id ?? 0).toString()));
}

export async function AssignJob(jobId: string, param: JobAssignRequestModel[]): Promise<APIResult<JobAllocation[]>> {
    const apiUrl = `${ApiEndPoints.job_assign}`;
    return await WebAPIClient.patchData<JobAllocation[]>(apiUrl.replace("{id}", (jobId ?? 0).toString()), param);
}


